import { Injectable } from '@angular/core';

// import { MatomoTracker } from '@ngx-matomo/tracker';

@Injectable( { providedIn: 'root' } )
export class LogAnalyticsService {

	readonly MODAL = 'Modal';

	constructor(
		// private readonly _matomoTracker: MatomoTracker,
	) { }

	/**
	 * Log the modal view into matomo. Determines modal name from dataList or use modalComponentName.
	 */
	public logModalView( dataList: { key: string, value: string }[], modalComponentName: string ): void {
		const value: string = dataList?.find( ( item: { key: string, value: string } ) => item.key === 'modalIdentifier' )?.value;
		// this._matomoTracker.trackPageView( this.MODAL + ': '	+ ( value ? value : modalComponentName ) );
	}
}
